<template>
  <div class="ioc-report-alarm__wrap" :style="miniAlarmStyle">
    <div class="ioc-report-alarm-panel" :class="{ 'panel-show': showAlarmPanel }">
      <div :class="[transparent ? 'map-blur-panel' : '', 'blur-bg']"></div>
      <div class="ioc-report-alarm__content">
        <div class="title">上报告警</div>
        <el-scrollbar class="scroll-content" style="height: calc(100% - 80px)">
          <el-form
            :model="alarmInfo"
            :rules="rulesForm"
            ref="alarmForm"
            class="form"
            label-width="80px"
          >
            <el-form-item label="监控点">
              <el-input v-model="info.name" readonly placeholder="无设备信息"> </el-input>
            </el-form-item>
            <el-form-item label="告警类型" prop="alarmType">
              <el-select
                v-model="alarmInfo.alarmType"
                style="width: 100%"
                placeholder="请选择告警类型"
              >
                <el-option
                  v-for="item in alarmTypes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option
              ></el-select>
            </el-form-item>
            <el-form-item label="告警级别" prop="alarmLevel">
              <el-select
                v-model="alarmInfo.alarmLevel"
                style="width: 100%"
                placeholder="请选择告警级别"
              >
                <el-option
                  v-for="item in alarmLevels"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="告警描述" prop="desc">
              <el-input
                v-model="alarmInfo.desc"
                placeholder="请输入告警描述"
                type="textarea"
                maxlength="200"
                show-word-limit
                rows="5"
                resize="none"
              ></el-input>
            </el-form-item>
            <el-form-item label="抓拍图片" prop="picture" label-width="80px">
              <template>
                <div class="file-upload-area">
                  <div class="file-list">
                    <div
                      class="file-item"
                      v-for="(item, index) in alarmInfo.pictureList"
                      :key="index"
                    >
                      <img class="file-comp" :src="$utils.Bus.imgPath(item.fileId)" />
                      <div class="delete-icon" @click="pictureRemove(index)">
                        <i class="el-icon-delete"></i>
                      </div>
                    </div>
                  </div>
                  <el-upload
                    v-loading="uploading"
                    element-loading-text="抓拍中..."
                    element-loading-spinner="el-icon-loading"
                    :class="{ hideUpload: alarmInfo.pictureList.length >= 3 }"
                    :action="uploadUrl"
                    name="files"
                    list-type="picture-card"
                    accept="image/png, image/jpg, image/jpeg, image/bpm"
                    :before-upload="pictureBefore"
                    :on-exceed="pictureExceed"
                    :on-success="pictureSuccess"
                    :file-list="alarmInfo.pictureList"
                    :show-file-list="false"
                    :auto-upload="true"
                    multiple
                    :limit="3"
                    ref="uploadPicture"
                  >
                    <el-button slot="trigger" size="small" type="text">
                      <i class="el-icon-circle-plus-outline" title="本地上传"></i>
                      <i
                        class="el-icon-camera"
                        @click.stop="handleSnap"
                        title="快速抓拍"
                      ></i>
                    </el-button>
                  </el-upload>
                </div>
              </template>
            </el-form-item>
          </el-form>
        </el-scrollbar>

        <div class="footer">
          <el-button @click="handleClosePanel" type="info">取消</el-button>
          <el-button type="primary" @click="handleConfirmPanel">立即上报</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Dic } from "$utils";
export default {
  name: "alarm-panel",
  props: {
    miniAlarmStyle: {
      type: Object,
      default: () => {
        return {
          // right:""
          // top:""
          // left:""
          // bottom:""
        };
      },
    },
    // 是否需要透明
    transparent: {
      type: Boolean,
      default: () => {
        return true;
      },
    },
    info: {
      type: Object,
      default: () => {
        return {
          //   name: "",//摄像机名称
          //   thirdCameraId: "",//摄像机id
          //   playRecordId: "",//窗口id
        };
      },
    },
    showAlarmPanel: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  data() {
    return {
      uploading: false,
      uploadUrl: "",
      rulesForm: {
        // name: [{ required: true, message: "请选择左侧监控点", trigger: "blur" }],
        alarmType: [{ required: true, message: "请选择告警类型", trigger: "blur" }],
        alarmLevel: [{ required: true, message: "请选择告警等级", trigger: "blur" }],
      },
      alarmInfo: {
        alarmType: "",
        alarmLevel: "",
        desc: "",
        picture: "",
        pictureList: [],
      },
      alarmLevels: Dic.find("SENU017"), //告警级别
      alarmTypes: Dic.find("SENU004009"),
      // alarmTypes: Dic.find("SENU004010"),
    };
  },
  mounted() {
    this.uploadUrl = this.$api.common.uploadFile;
  },
  methods: {
    convertBase64UrlToBlob(urlData) {
      var bytes = window.atob(urlData.split(",")[1]); //去掉url的头，并转换为byte
      //处理异常,将ascii码小于0的转换为大于0
      var ab = new ArrayBuffer(bytes.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i);
      }
      // var blob = new Blob([ab], {type: 'image/jpeg'}); //type为图片的格式
      return new Blob([ab], { type: "image/png" });
    },
    // 快速抓拍
    handleSnap() {
      imosSdk.playCatch(this.info.playRecordId, (result) => {
        console.log("抓拍图片", result);
        if (result.ErrCode == 0) {
          let formData = new FormData();
          let file = this.convertBase64UrlToBlob(result.Img);
          formData.append("files", file, new Date().getTime() + ".jpg");
          this.uploading = true;
          this.$fetch(this.$api.common.uploadFile, formData).then((res) => {
            this.uploading = false;
            if (res.success) {
              this.pictureSuccess(res);
            }
          });
        } else {
          this.$message.error("抓拍图片出错");
        }
      });
      //
    },
    handleConfirmPanel() {
      this.$refs.alarmForm.validate((result) => {
        if (result) {
          let params = {
            desc: this.alarmInfo.desc,
            alarmType: this.alarmInfo.alarmType, //类型
            alarmLevel: this.alarmInfo.alarmLevel, //级别
            // picUrl  alarmSnapUrl
            picUrl: (this.alarmInfo.pictureList || [])
              .map((item) => {
                return item.fileId;
              })
              .join(","), //图片
            isApp: 0,
            thirdAlarmDevId: this.info.thirdCameraId, //摄像机id
          };
          this.$fetch(this.$api.common.operateAlarm, params).then((response) => {
            if (response.success) {
              this.$message.success("报警上报成功");
              this.handleClosePanel();
            } else {
              this.$message.error(response.msgContent || "上报告警失败");
            }
          });
        }
      });
    },
    pictureSuccess(res) {
      this.alarmInfo.pictureList = this.alarmInfo.pictureList.concat(res.returnObj || []);
    },
    pictureExceed() {
      this.$message.warning("最多可上传3张图片");
    },
    pictureRemove(index) {
      this.alarmInfo.pictureList.splice(index, 1);
    },
    pictureBefore(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("视频大小请不要超过2MB");
      }
      return isLt2M;
    },
    handleClosePanel() {
      this.alarmInfo.pictureList = [];
      this.$refs.alarmForm.resetFields();
      this.$emit("handleClosePanel");
    },
  },
};
</script>

<style lang="scss">
@import "~@src/common/assets/style/mixin";
.blur-bg {
  @include set_theme_color(background-color,map-bg-color);
}

.ioc-report-alarm {
  &__wrap {
    position: absolute;
    top: 0px;
    display: flex;
    right: 0px;
    height: 100%;
    z-index: 9;

    .panel-show {
      padding: 12px;
      width: 340px;
      height: 100%;
      position: absolute;
      top: 0;
      right: 0px !important;
      @include set_animation(all);
    }
    .ioc-report-alarm-panel {
      padding: 10px;
      width: 340px;
      height: 100%;
      position: absolute;
      top: 0;
      right: -450px;
      @include set_animation(all);
    }
  }

  &__content {
    height: calc(100% - 20px);
    width: calc(100% - 20px);
    position: absolute;
    .title {
      border-left: 4px solid #407aee;
      position: relative;
      line-height: 16px;
      text-align: left;
      padding-left: 10px;
      font-size: 16px;
      margin: 0px 10px 20px;
    }
    .form {
      @include set_theme_color(background-color, map-bg-color);
      padding: 10px;
    }
    .file-upload-area {
      display: flex;
      flex-direction: row;
      // justify-content: space-between;
    }

    .file-list {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
    }

    .file-item {
      margin-right: 10px;
      background-color: #ffffff;
      position: relative;

      .delete-icon {
        position: absolute;
        right: 0;
        top: 0;
        width: 24px;
        height: 24px;
        background-color: rgba($color: #000000, $alpha: 0.5);
        cursor: pointer;
        color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: all 0.2s;

        &:hover {
          background-color: rgba($color: #000000, $alpha: 0.8);
        }

        &:active {
          color: #aaaaaa;
        }
      }
    }

    .file-item,
    .file-comp,
    .el-upload--picture-card,
    .el-upload-list--picture-card .el-upload-list__item {
      height: 100px;
      width: 108px;
      line-height: 110px;
      margin-bottom: 10px;
      @include set_theme_color(background-color, input-default-bg-color);
      &:nth-child(3) {
        margin-right: 0;
      }
      button {
        i {
          font-size: 26px;
          margin-left: 8px;
          margin-right: 8px;
          @include set_theme_color(color, main-theme-color);
        }
      }
    }
    .hideUpload {
      .el-upload--picture-card {
        display: none;
      }
    }
    .row {
      @include set_theme_color(background-color, map-panel-content);
    }
    .item-content {
      margin: 12px;
      display: flex;
      line-height: 24px;
    }
    .item-label {
      width: 80px;
    }
    .item-value {
      line-height: 24px;
    }
    .footer {
      width: 100%;
      text-align: center;
      position: absolute;
    }
  }
}
</style>
